import { Reducer } from "redux"
import { Map } from "immutable"
import { TemplateAPIType, AuthUserType } from "../../../Actions/Types"
import { TemplateName } from "../../../Models/API/AppTemplateModel"
import { AuthAction } from "../../Auth"
import { FetchState } from "../../../Models/Client/FetchState"

export type AppTemplateAvailabilityState = Map<
    TemplateName,
    FetchState<boolean>
>

interface AppTemplateSetAvailabilityAction {
    type: TemplateAPIType.setAvailability
    meta: {
        name: TemplateName
    }
    payload: FetchState<boolean>
}

export type AppTemplateAvailabilityAction = AppTemplateSetAvailabilityAction

const initialState: AppTemplateAvailabilityState =
    Map<TemplateName, FetchState<boolean>>()

export const AppTemplateAvailabilityReducer: Reducer<
    AppTemplateAvailabilityState,
    AppTemplateAvailabilityAction | AuthAction
> = (state = initialState, action): AppTemplateAvailabilityState => {
    switch (action.type) {
        case TemplateAPIType.setAvailability:
            return state.set(action.meta.name, action.payload)
        case AuthUserType.signedIn:
        case AuthUserType.signedOut:
            return initialState
        default:
            return state
    }
}
